export default function GroupBuy() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editingItem, setEditingItem] = useState(null)
  const [form, setForm] = useState({ title: '', description: '', originalPrice: 0, groupbuyPrice: 0, minMembers: 3 })

  useEffect(() => {
    fetch(`${API}/groupbuy`)
      .then(r => r.json())
      .then(d => { if (d.success) setOrders(d.data || []) })
      .catch(e => { console.error(e) })
      .finally(() => setLoading(false))
  }, [])

  const handleAdd = () => {
    setEditingItem(null)
    setForm({ title: '', description: '', originalPrice: 0, groupbuyPrice: 0, minMembers: 3 })
    setShowModal(true)
  }

  const handleEdit = (item) => {
    setEditingItem(item)
    setForm({
      title: item.title || '',
      description: item.description || '',
      originalPrice: item.originalPrice || 0,
      groupbuyPrice: item.groupbuyPrice || 0,
      minMembers: item.minMembers || 3
    })
    setShowModal(true)
  }

  const handleSave = async () => {
    if (!form.title) { alert('请输入标题'); return }
    try {
      const method = editingItem ? 'PUT' : 'POST'
      const url = editingItem ? `${API}/groupbuy/${editingItem.id}` : `${API}/groupbuy`
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) {
        setShowModal(false)
        const refreshed = await fetch(`${API}/groupbuy`).then(r => r.json())
        if (refreshed.success) setOrders(refreshed.data || [])
        alert(editingItem ? '修改成功' : '添加成功')
      } else {
        alert(data.error || '操作失败')
      }
    } catch (e) { alert('操作失败') }
  }

  const handleDelete = async (id) => {
    if (!confirm('确定删除？')) return
    try {
      const res = await fetch(`${API}/groupbuy/${id}`, { method: 'DELETE' })
      const data = await res.json()
      if (data.success) {
        setOrders(orders.filter(o => o.id !== id))
        alert('删除成功')
      }
    } catch {}
  }

  const stats = {
    ongoing: orders.filter(o => o.status === 'active').length,
    completed: orders.filter(o => o.status === 'completed').length,
    total: orders.length
  }

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>👥 团购活动</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>管理团购活动和订单</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>进行中</div><div style={{ fontSize: 28, color: '#1890ff' }}>{stats.ongoing}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>已完成</div><div style={{ fontSize: 28, color: '#52c41a' }}>{stats.completed}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>总数量</div><div style={{ fontSize: 28, color: '#722ed1' }}>{stats.total}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>总参与</div><div style={{ fontSize: 28, color: '#fa8c16' }}>{orders.reduce((s, o) => s + (o.currentMembers || 0), 0)}</div></div>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, padding: 16, marginBottom: 20 }}>
        <button onClick={handleAdd} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>+ 添加团购</button>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>标题</th>
              <th style={th}>原价</th>
              <th style={th}>团购价</th>
              <th style={th}>最低人数</th>
              <th style={th}>当前人数</th>
              <th style={th}>状态</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{o.title}</td>
                <td style={td}>¥{o.originalPrice || 0}</td>
                <td style={{ ...td, color: '#ff4d4f', fontWeight: 'bold' }}>¥{o.groupbuyPrice || 0}</td>
                <td style={td}>{o.minMembers || 0}</td>
                <td style={td}>{o.currentMembers || 0}</td>
                <td style={td}>
                  <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: o.status === 'active' ? '#e6f7ff' : '#f0f0f0', color: o.status === 'active' ? '#1890ff' : '#999' }}>
                    {o.status === 'active' ? '进行中' : o.status === 'completed' ? '已完成' : '已结束'}
                  </span>
                </td>
                <td style={td}>
                  <button onClick={() => handleEdit(o)} style={{ ...btn, background: '#1890ff', color: '#fff', marginRight: 8 }}>编辑</button>
                  <button onClick={() => handleDelete(o.id)} style={{ ...btn, background: '#ff4d4f', color: '#fff' }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无团购数据</div>}
      </div>

      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 480 }}>
            <h3 style={{ marginBottom: 16 }}>{editingItem ? '编辑团购' : '添加团购'}</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>标题 *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>描述</label>
              <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4, height: 60 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>原价</label>
                <input type="number" value={form.originalPrice} onChange={e => setForm({ ...form, originalPrice: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>团购价</label>
                <input type="number" value={form.groupbuyPrice} onChange={e => setForm({ ...form, groupbuyPrice: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>最低人数</label>
                <input type="number" value={form.minMembers} onChange={e => setForm({ ...form, minMembers: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '8px 16px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}>取消</button>
              <button onClick={handleSave} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4 }}>保存</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }
const th = { padding: 14, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 14, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
